<script setup lang="ts">
import { NOTICE_TYPE_ENUM, type Notice } from "@gasparigit/omnia-sdk";
import { DateFormatter } from "@internationalized/date";
import { link } from "~/lib/utils/contents";
import type { CreateLinkConfig } from "~/utils/types";

defineProps<{
  content: Notice;
  compact?: boolean;
  showAreas?: boolean;
  linkConfig?: CreateLinkConfig;
}>();

const df = new DateFormatter("it-IT", { dateStyle: "long" });
</script>

<template>
  <FrontContentItemsBaseItem
    v-bind="$props"
    :link="link({ ...linkConfig, notice: content })"
    :title="content.title"
    :abstract="content.abstract"
    :show-areas="showAreas"
    :compact="compact"
    :info-label="NOTICE_TYPE_ENUM[content.type]"
  >
    <template #info>
      <p class="info-number my-2">Avviso del {{ df.format(content.published_at || content.created_at) }}</p>
    </template>
  </FrontContentItemsBaseItem>
</template>
